import React from 'react';
import Button from 'jbc-front/components/Button';
import { useEmployeeMutation } from '@jbc-year-end-adj/2024/hooks/graphql/useMutation';
import { gql } from '@apollo/client';
import { Start as StartTemplate } from '@jbc-year-end-adj/2024/features/questions/templates/Start';

// @ts-ignore
import { Panel, Headding, Item, Lead, Buttons } from '@jbc-year-end-adj/2024/components/PrimaryPanel';
import useReactRouter from 'use-react-router';
// @ts-ignore
import { CustomDescription } from '@jbc-year-end-adj/2024/components/QuestionDescription';
import { Question } from '@jbc-year-end-adj/2024/features/questions/types';

const ANSWER_START = gql`
  mutation answerStart {
    answerStart(input: { start: true }) {
      questions {
        id
        status
      }
    }
  }
`;

interface StartProps {
  question: Question;
}

export const Start = ({ question }: StartProps) => {
  const [answer, { loading }] = useEmployeeMutation(ANSWER_START);
  const { history } = useReactRouter();
  return (
    <StartTemplate question={question}>
      <Buttons>
        <Button
          huge
          secondary
          onClick={async () => {
            await answer();
            history.push('/employee_input');
          }}
          disabled={loading}
        >
          年末調整を始める
        </Button>
      </Buttons>
    </StartTemplate>
  );
};
